
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, bool_type, lambda_type, unit_type, union_type, list_type, class_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__setValidationResponse_5219762A, FormState__startLoading, SetId, FormState_get_empty, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../../Widgets/Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { DataTransfer_UnassignSetNotificationDto, DataTransfer_DetailSet_$reflection } from "../../Shared/Set.js";
import { ofArray, singleton, append, max, filter, tryPick, sumBy, choose, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { unassignWithNotificationCmd } from "../../Requests/Set.js";
import { uploadImage } from "../../Requests/Files.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { createObj, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../Components/Dialog.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextArea } from "../../Components/TextArea.js";
import { TextValue } from "../../Components/Text.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { TextButton } from "../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ReturnResponse", "OnReturn", "SetComment", "FetchError", "SetSelectedSenderFiles", "SenderImageUploaded"];
    }
}

function Msg_$reflection() {
    return union_type("Sets.Dialog.ReturnSetNotificationDialog.Msg", [], Msg, () => [[["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", string_type]], [["Item", class_type("System.Exception")]], [["Item", list_type(DnDFormImage_$reflection())]], [["Item", FileUploadResponse_$reflection()]]]);
}

class State extends Record {
    constructor(Set$, Comment$, SuccessCallback, OnClose, FormState, SenderImageFiles, ImageUploading) {
        super();
        this.Set = Set$;
        this.Comment = Comment$;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.FormState = FormState;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
    }
}

function State_$reflection() {
    return record_type("Sets.Dialog.ReturnSetNotificationDialog.State", [], State, () => [["Set", DataTransfer_DetailSet_$reflection()], ["Comment", string_type], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["FormState", FormState_$reflection()], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type]]);
}

const maxSenderImages = 5;

function init(set$, successCallback, onClose) {
    return [new State(set$, "", successCallback, onClose, FormState_get_empty(), empty(), false), Cmd_none()];
}

function update(msg, state) {
    let file_1;
    switch (msg.tag) {
        case 1: {
            const dto = new DataTransfer_UnassignSetNotificationDto(undefined, state.Comment, "userToStorage", choose((f) => {
                if (f.tag === 1) {
                    return f.fields[0].ImageUrl;
                }
                else {
                    return undefined;
                }
            }, state.SenderImageFiles));
            const setId = new SetId(parse(state.Set.Id));
            return [new State(state.Set, state.Comment, state.SuccessCallback, state.OnClose, FormState__startLoading(state.FormState), state.SenderImageFiles, state.ImageUploading), unassignWithNotificationCmd(setId, dto, (Item_1) => (new Msg(0, [Item_1])), (Item_2) => (new Msg(3, [Item_2])))];
        }
        case 2:
            return [new State(state.Set, msg.fields[0], state.SuccessCallback, state.OnClose, state.FormState, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 3:
            return [new State(state.Set, state.Comment, state.SuccessCallback, state.OnClose, state.FormState, state.SenderImageFiles, false), Cmd_none()];
        case 4: {
            const newFiles = msg.fields[0];
            const alreadyUploadedCount = sumBy((f_1) => {
                if (f_1.tag === 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }, state.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x, y) => ((x + y) | 0),
            }) | 0;
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            let matchResult, file_2;
            if (pickedFile != null) {
                if ((file_1 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult = 0;
                    file_2 = pickedFile;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_2.name, file_2);
                    return [new State(state.Set, state.Comment, state.SuccessCallback, state.OnClose, state.FormState, newFiles, true), uploadImage((Item_3) => (new Msg(5, [Item_3])), (Item_4) => (new Msg(3, [Item_4])), formData)];
                }
                default:
                    return [new State(state.Set, state.Comment, state.SuccessCallback, state.OnClose, state.FormState, newFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 5: {
            const response_1 = msg.fields[0];
            switch (response_1.tag) {
                case 0:
                    return [new State(state.Set, state.Comment, state.SuccessCallback, state.OnClose, state.FormState, filter((f_5) => {
                        if (f_5.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.Set, state.Comment, state.SuccessCallback, state.OnClose, state.FormState, filter((f_6) => {
                        if (f_6.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.a_error_occured")];
                default: {
                    const nextPosition = (1 + max(append(singleton(0), choose((f_3) => {
                        if (f_3.tag === 1) {
                            return f_3.fields[0].Position;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles)), {
                        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                    })) | 0;
                    return [new State(state.Set, state.Comment, state.SuccessCallback, state.OnClose, state.FormState, append(choose((f_4) => {
                        if (f_4.tag === 1) {
                            return f_4;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles), singleton(new DnDFormImage(1, [{
                        ImageUrl: response_1.fields[0].ImageUrl,
                        Position: nextPosition,
                    }]))), false), Cmd_none()];
                }
            }
        }
        default: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Set, state.Comment, state.SuccessCallback, state.OnClose, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.SenderImageFiles, state.ImageUploading), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Set, state.Comment, state.SuccessCallback, state.OnClose, FormState_get_empty(), state.SenderImageFiles, state.ImageUploading), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
    }
}

export function ReturnSetNotificationDialog(props) {
    let Title, elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Set, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("tool.return_notification_title"), {
        Body: singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-5"])], (elems_1 = toList(delay(() => append_1(singleton_1(reactElement("p", {
            children: t("tool.return_notification_description"),
        })), delay(() => append_1(singleton_1(createElement(TextArea, {
            ComponentState: componentState,
            Label: t("general.comment"),
            OnChange: (value_3) => {
                dispatch(new Msg(2, [value_3]));
            },
            TestId: "return-set-notification-dialog-comment-test-id",
            Value: state_1.Comment,
        })), delay(() => {
            let elems;
            return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems = [createElement(TextValue, {
                FontWeight: "bold",
                TestId: "",
                Text: t("assignment_notification.sender_images"),
            }), createElement(ImageUpload, {
                ComponentState: state_1.ImageUploading ? "disabled" : componentState,
                SelectedFiles: state_1.SenderImageFiles,
                SetSelectedFile: (files) => {
                    dispatch(new Msg(4, [files]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                const matchValue = FormState__getValidation(state_1.FormState, t, "global");
                if (matchValue == null) {
                    return empty_1();
                }
                else {
                    return singleton_1(createElement(ErrorAlert, {
                        Label: matchValue,
                    }));
                }
            }));
        })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-return-set-notification-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: state_1.ImageUploading ? "disabled" : componentState,
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(1, []));
            },
            TestId: "save-return-set-notification-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

